<template>
  <div
    @contextmenu="selectComponentDEV($event, schema.model)"
    :class="['drag-upload', getSelectedDEV && 'dev-selected-component']"
    :key="generateId('files')"
  >
    <div class="dropzone" @click="openFile()">
      <h3>Arraste e solte para fazer upload de arquivos!</h3>
      <label for="file" ref="startFile">... ou clique para selecionar seus arquivos</label>
    </div>

    <div v-show="$refs.upload && $refs.upload.dropActive" class="drop-active animated heartBeat">
      <h2>Soltar arquivos para upload</h2>
    </div>

    <file-upload
      v-show="false"
      v-model="files"
      ref="upload"
      @input-file="addFile"
      @input-filter="inputFilter"
      v-bind="attributes || schema.attributes"
    >
      <v-icon>attach_file</v-icon>Selecionar arquivos
    </file-upload>

    <v-card class="mt-4">
      <v-list class="p-0" dense v-if="files.length">
        <v-list-item-group v-model="item" color="primary">
          <template v-for="(file, index) in files">
            <v-list-item :key="file.name">
              <v-list-item-avatar color="primary">
                <v-icon size="25" class="white--text" v-text="checkExtension(file.type)"></v-icon>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title v-text="file.name"></v-list-item-title>
                <v-list-item-subtitle>{{ file.size | formatSize }}</v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-action>
                <v-tooltip left color="primary">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      data-has-tooltip="true"
                      data-tooltip="Remover Arquivo"
                      v-on="on"
                      v-bind="attrs"
                      icon
                      @click="removeFile(file)"
                    >
                      <v-icon size color="grey lighten-1">close</v-icon>
                    </v-btn>
                  </template>
                  <span>Remover Arquivo</span>
                </v-tooltip>
              </v-list-item-action>
            </v-list-item>
            <v-divider v-if="index + 1 < files.length" :key="index" />
          </template>
        </v-list-item-group>
      </v-list>
    </v-card>
  </div>
</template>

<script>
import { abstractField } from 'vue-form-generator';
import devComponentMixin from '@/mixins/dev-component-mixin';
import { getIcon } from '@/helpers/utils';

import FileUpload from 'vue-upload-component';
import validatorAcceptInputFileMixin from '@/mixins/validator-accept-input-file-mixin';
import componentMixin from '@/mixins/component-mixin';

export default {
  mixins: [abstractField, devComponentMixin, validatorAcceptInputFileMixin, componentMixin],

  components: {
    FileUpload
  },

  data: () => ({
    item: null,
    files: [],
    listAcceptIncorrect: []
  }),

  props: {
    attributes: { type: Object }
  },

  watch: {
    value(newValue, oldValue) {
      if (newValue !== oldValue && !newValue) {
        this.files = [];
      }
    }
  },

  methods: {
    openFile() {
      this.$refs.startFile.click();
    },

    removeFile(file) {
      let index = this.files.indexOf(file);
      index !== -1 && this.files.splice(index, 1);

      this.$emit('remove-file', this.files);
    },

    addFile(newFile, oldFile) {
      this.listAcceptIncorrect.forEach(itemAccept => {
        this.files.forEach((item, index) => {
          if (itemAccept.id == item.id) {
            this.files.splice(index, 1);
          }
        });
      });

      if (this.schema) {            
        const filesIsMultiple = (this.attributes?.multiple || this.schema.attributes?.multiple)
        this.value = filesIsMultiple ? this?.files : this.files[0]?.file;
      }
      this.$emit('add-file', this.files);
    },

    inputFilter: function (newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        const validAcceptError = this.validatorAcceptInputFile((this.attributes || this.schema.attributes), newFile);

        // verifica na validação se o arquivo é valido de acordo com o accept do json, se não for valido add no array
        if (!validAcceptError) {
          this.listAcceptIncorrect.push(newFile);
        }
      }
    },

    checkExtension(type) {
      return getIcon(type);
    }
  },

  filters: {
    formatSize(size) {
      if (size > 1024 * 1024 * 1024 * 1024) {
        return `${(size / 1024 / 1024 / 1024 / 1024).toFixed(2)} TB`;
      } else if (size > 1024 * 1024 * 1024) {
        return `${(size / 1024 / 1024 / 1024).toFixed(2)} GB`;
      } else if (size > 1024 * 1024) {
        return `${(size / 1024 / 1024).toFixed(2)} MB`;
      } else if (size > 1024) {
        return `${(size / 1024).toFixed(2)} KB`;
      }

      return `${size.toString()} B`;
    }
  }
};
</script>

<style lang="scss" scoped>
.drag-upload {
  .dropzone {
    border: 2px solid #cacaca;
    cursor: pointer;
    letter-spacing: 0.2px;
    padding: 20px;
    text-align: center;
    transition: 0.5s;
    label {
      cursor: pointer;
    }
    h3 {
      color: var(--v-primary-base);
      font-weight: 600;
      margin-top: 0;
    }

    &:hover {
      border-color: var(--v-primary-base);
      transition: 0.5s;
    }
  }

  .drop-active {
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    position: fixed;
    z-index: 9999;
    opacity: 0.7;
    text-align: center;
    background: #000;

    h2 {
      margin: -0.5em 0 0;
      position: absolute;
      top: 50%;
      left: 0;
      right: 0;
      transform: translateY(-50%);
      font-size: 40px;
      color: #fff;
      padding: 0;
    }
  }
}

.theme--dark {
  .dropzone {
    background-color: #424242;
    &:hover {
      background-color: #303030;
    }
  }
}

.theme--light {
  .dropzone {
    background-color: #fff;
    &:hover {
      background-color: #f4f4f4;
    }
  }
}
</style>
